'use client';

import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from '@datadog/browser-rum';

if (typeof document !== 'undefined') {
    let metaTag = document.querySelector('meta[name="build-number"]');
    if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('name', 'build-number');
        document.head.appendChild(metaTag);
    }
    metaTag.setAttribute('content', process.env.NEXT_PUBLIC_BUILD_NUMBER || 'unknown');
}

if (process.env.NEXT_PUBLIC_ENV !== 'dev' && process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID && process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN) {
    datadogLogs.init({
        clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN!,
        site: "datadoghq.com",
        service: "fipe-next-ui",
        env: process.env.NEXT_PUBLIC_ENV || "development",
        forwardErrorsToLogs: true,
    });


    datadogRum.init({
        applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
        clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
        env: process.env.NEXT_PUBLIC_ENV,
        site: 'datadoghq.com',
        service: 'fipe-nextjs',
        version: process.env.NEXT_PUBLIC_BUILD_NUMBER,
        sessionSampleRate: 20, // coleta 20% dos acessos
        sessionReplaySampleRate: 20, // coleta 20% dos acessos
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        defaultPrivacyLevel: 'mask-user-input',
        beforeSend: (event, _context) => {
            if (event.type === 'error' && event.error.message.startsWith('console error: Error: s:0 rs:4')) {
                return false;
            }
            return true;
        },
    });
}

export default function DatadogInit() {
    return null;
}
